import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { checkTranslation, getObject, pathMaker, setObject, translate } from "../../../utils/useful";
import HttpServices from "../../../utils/Http.services";
import FormViewer from "../../../components/FormViewer";
import ButtonAnimated from "../../../components/buttons/ButtonAnimated";
import CustomLoader from "../../../components/CustomLoader";
import Modal from "../../../components/Modal";

class ConfigView extends Component {

    openEditModal = (prop, index) => {
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    state = {
        data: [],
        actions: {
            add: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal },
            edit: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
        currentPage: 0,
        limit: 10,
        fields: []
    }

    componentDidMount() {
        this.init()

        if (this.props.setHeader) {
            this.props.setHeader({
                title: this.props.title,
                // 'toolbar': null,
                // 'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.cancel()
            })

            setTimeout(() => {
                this.setState({ revealFixed: true }, () => {
                    this.props.setHeader("dummy", 1)
                })
            }, 50);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            this.init()
        }
    }


    headerIdentityComponent = () => {
        return (
            <div className='white d-flex flex-column' >
                <p className="text-semibold text-small">{translate("Page config")}</p>
                <p className="text-semibold text-smallest">{translate(this.props.name)}</p>
            </div>
        )
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <div className='flexcc px-1'>
                    <button className={" px-3 py-2 flexc br-20 " + " add-element "} onClick={() => this.props.applyConfig()}>
                        {/* <img className='prd-1 ' width={22} src='/assets/icons/pagebuilder/plus-black.svg' /> */}
                        <p className='font-size-14 black weight-500' style={{ whiteSpace: 'nowrap' }}>{translate('Apply Config')}</p>
                    </button>
                </div>


                {/* <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.state.isLoadingData ? () => { } : () => this.save()}
                    title='Save'
                    icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    isLoading={this.state.isLoadingData}
                /> */}
            </div>
        )
    }


    init() {
        if (this.props.page) {

            let fields = [...this.props.page?.headers]

            this.setState({ data: [], fields }, () => {
                this.fetchData(true)
            })
            this.setHeader()
        }
    }

    setHeader = () => {
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                'title': this.props.page?.title,
                'subtitle': this.props.page?.subtitle,
                backAction: () => this.props.changePage('')
            })
        }
    }

    fetchData = (getCount) => {

        let page = this.props.page

        if (this.props.initData) {
            this.setState({ initData: this.props.initData })

        }

        if (page.fetchUrl) {
            this.setState({ isLoadingData: true })
            let body = {}
            body.page = page.key
            body.limit = this.state.limit
            body.skip = this.state.currentPage
            if (page.filter) {
                body = { ...body, ...page.filter }
            }
            if (this.state.totalCount == null || getCount) {
                body.getCount = true
            }
            for (const [key, value] of Object.entries(body)) {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }


            // console.log(page.fetchUrl)
            // console.log(body)
            // console.log(page.fetchUrl)

            HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {

                // console.log(fetchResult)
                this.setState({ isLoadingData: false })
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                // TO DO SHOULD BE BASED ON TYPE
                if (this.props.page.key == 'config' && !fetchResult.user?.family) {
                    let fields = []

                    this.props.page?.headers.forEach(header => {
                        if (header.key != 'birthdate' && header.key != 'family')
                            fields.push(header)
                    });

                    this.setState({ fields })
                }


                // { console.log('fetressssssssssssww', fetchResult) }
                if (page.fetchUrl == 'getUserInfo') {

                    this.setState({ initData: fetchResult.user })
                } else {

                    this.setState({ initData: fetchResult.info })
                }
                if (fetchResult.count) {
                    this.setState({ totalCount: fetchResult.count })
                }
            })
        }
    }

    submitForm = () => {
        let data = this.form.getForm()
        // console.log('updateUserInfosubmitformdata', data)


        if (data) {

            // console.log('submitForm',data)
            // console.log('this.props.submitForm',this.props.submitForm)
            if (this.props.submitForm) {
                this.props.submitForm(data, () => {

                })
            } else {

                this.setState({ isLoadingUpdate: true })
                // console.log('data', { ...data })
                // console.log('this.props.page.editUrl', this.props.page.editUrl)
                // data.image = data.images[0]
                // return
                HttpServices.request(this.props.page.editUrl, data, (fetchResult, fetchError) => {
                    // console.log('updateUserInfosubmitformres', fetchResult)
                    // console.log('updateUserInfosubmitformerr', fetchError)
                    this.setState({ isLoadingUpdate: false })
                    if (fetchError) {
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: fetchError.message })
                        return
                    }
                    // console.log('fetchError', fetchError)
                    // console.log('fetchResult', fetchResult)
                    this.props.page.headers.map((element) => {
                        let object = getObject(fetchResult.user, element.key)
                        this.setData(`applet.${element.key}`, object, 'Applet')
                    })
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.updateSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
                    this.setState({ isLoadingUpdate: false })
                })
            }
        }
    }

    itemAdded = (newItem) => {
        let data = this.state.data
        data.splice(0, 0, newItem)
        this.setState(data)
    }

    itemEdited = (editedItem) => {
        let data = this.state.data
        this.state.data.forEach((element, index) => {
            let id = element.id ?? element._id
            let currentId = this.state.currentItem.id ?? this.state.currentItem._id
            if (id === currentId) {
                data[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ data }, () => {
        })
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'ConfigView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }
    changePage = (page) => {
        if (this.props.changePage) {
            this.props.changePage(page)
        }
        if (this.props.cancel) {
            this.props.cancel()
        }
    }

    render() {

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        let background = `linear-gradient(90deg, ${this.props.colors?.primaryColor}, ${this.props.colors?.secondaryColor})`

        return (
            <div className="h-100 sc-gray4" style={{ backgroundColor: '#f0f0f0', overflow: 'auto' }}>
                <div className=" " >
                    <div className="row m-0">
                        <div className=" mb-5 mt-2 w-100 p-2 flexc flex-column">
                            <div className="p-3 px-4 " style={{ width: '100%', maxWidth: 600, backgroundColor: '#fff', borderRadius: 20 }}>
                                {this.state.isLoadingData && (
                                    <div className="flexcc flex-column py-5">
                                        <CustomLoader color={"#007aff"} isLoading={true} width={30} height={30} />
                                        <p className="text-smaller mt-1 color-gray-3">{translate("is Loading ...")}</p>
                                    </div>
                                )}
                                {!this.state.isLoadingData && (
                                    <>
                                        <div className="px-2 mb-4" >
                                            <div className="p-0" style={{ borderRadius: 0 }}>
                                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>
                                                    <div className="flexc mt-2 px-2">
                                                        <div>
                                                            <p className="text-semibig text-semibold m-0 " style={{ color: '#0d172a' }}>{checkTranslation(this.props.page?.title)}</p>
                                                            <p className="text-small m-0" style={{ color: '#89a' }} >{checkTranslation(this.props.page?.description)}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <FormViewer ref={el => this.form = el} headers={this.state.fields} initData={this.state.initData} errors={this.state.errors} inputClass={'modern-input'} variables={variables} />
                                        <div className="flexcb px-3 mb-4">
                                            <div className="flexc">
                                                <ButtonAnimated
                                                    iconwidth='28px'
                                                    isLoading={this.state.isLoadingUpdate}
                                                    onClick={this.submitForm}
                                                    title='{{lang}}Update'
                                                    icon='/assets/icons/save.svg'
                                                    invert={!this.props.colors?.iconInvert}
                                                    bg={background}
                                                    textColor={this.props.colors?.textColor}
                                                />
                                                <div className="px-2">
                                                    <ButtonAnimated
                                                        iconwidth='28px'
                                                        isLoading={this.state.isLoadingUpdate}
                                                        onClick={() => this.changePage('')}
                                                        title='{{lang}}Cancel'
                                                        invert={true}
                                                        bg={'linear-gradient(to right, #eee, #eee)'}
                                                        textColor={'#777'}
                                                    />
                                                </div>
                                            </div>
                                            <ButtonAnimated
                                                iconwidth='28px'
                                                // isLoading={this.state.isLoadingRemove}
                                                onClick={() => { this.deactivateModal.showModal() }}
                                                title='{{lang}}Deactivate'
                                                // icon='/assets/icons/save.svg'
                                                icon='/assets/icons/angle-right-white2.svg'
                                                bg={'linear-gradient(to right, #ef0b0bdd, #ef0b0bdd)'}
                                                textColor={'#fff'}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Modal maxWidth={400} ref={(el) => this.deactivateModal = el}  >
                    <div className="w-100  " style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                        <div className="p-4">
                            <p className="text-normal weight-600 pb-3" style={{}}>{translate("Are you sure you want to remove?")}</p>
                            {/* <p className="text-small weight-500 main-c7" style={{}}>{translate('drives.rethink-your-decision')}</p> */}
                            <div className="flexc w-100 pt-4" style={{ justifyContent: 'flex-end' }}>
                                <div className="flexc mrd-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.deactivateModal.hideModal(); }}
                                        title={translate('Cancel')}
                                        textColor={'#a3a2b0'}
                                        bg={'#eee'}
                                    />
                                </div>
                                <div className="flexc mld-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        // isLoading={this.state.isLoading}
                                        onClick={() => { }}
                                        title={translate('Delete')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={`linear-gradient(90deg, #ef0b0bdd, #ef0b0bdd)`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ConfigView);